export default __webpack_public_path__ + "static/media/logo-nema_simbolo-cores_rgb_fundo_escuro.aaf8d29b.png";